<template>
  <Modal v-model="isOpen">
    <div class="p-6">
      <h2 class="text-lg font-bold mb-4">명령어 예시</h2>
      <div class="space-y-6 overflow-y-auto max-h-[80vh]">
        <div v-for="(example, index) in examples" :key="index" class="space-y-2">
          <h3 class="font-semibold">{{ index + 1 }}. {{ example.title }}</h3>
          <p class="text-sm text-gray-600">- {{ example.description }}</p>
          <div class="flex justify-center">
            <img 
              :src="example.imageUrl" 
              :alt="example.title" 
              class="rounded-lg shadow-sm object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import { ref, computed } from 'vue';
import Modal from './ui/Modal.vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const isOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const examples = [
  {
    title: '/키워드',
    description: '크롤링된 데이터의 채널 별 게시물 수',
    imageUrl: 'https://prone-llm.s3.ap-northeast-2.amazonaws.com/functionImage/example_keyword/keyword_example.png'
  },
  {
    title: '/시각화',
    description: '설정된 기간, 채널의 일별 발생된 게시물 수',
    imageUrl: 'https://prone-llm.s3.ap-northeast-2.amazonaws.com/functionImage/visualization/124d3c6a-1e33-42a3-907f-c120fba502ea.png'
  },
  {
    title: '/긍부정',
    description: '설정된 기간, 채널에서 발생된 긍부정 게시물 수',
    imageUrl: 'https://prone-llm.s3.ap-northeast-2.amazonaws.com/functionImage/sentiment/0abbb617-1590-4a8a-b799-69c8e9f9529c.png'
  },
  {
    title: '/개수',
    description: '특정 기간 내 지정된 채널에서 키워드 언급 수',
    imageUrl: 'https://prone-llm.s3.ap-northeast-2.amazonaws.com/functionImage/count/31b3811b-6fd5-4ee4-a35c-ea5152e64438.png'
  },
  {
    title: '/워드클라우드',
    description: '설정된 기간, 채널, 긍부정 게시물에 대해 언급된 키워드 워드클라우드 이미지 생성',
    imageUrl: 'https://prone-llm.s3.ap-northeast-2.amazonaws.com/functionImage/wordcloud/8c0f3302-83f1-4264-a3ac-eda2bcdc1c97.png'
  }
];
</script>